export default __webpack_public_path__ + "52f39b031f8b52f6505110cd421ba658.svg";